import React from "react";
import OurProgrammePortfolioHeader from "../header/OurProgrammePortfolioHeader";

export const PortfolioHeader = ({settings, periods, ourProgrammeContext, overallGrouping, selectedKpi}) => {
    const kpiValue = overallGrouping ? selectedKpi.valueFor(overallGrouping) : null;
    const companyName = settings ? settings.portfolioCompanyName : "";
    const ownerName = settings && settings.internal ? "internal" : companyName;
    const numberOfNewIdeas = overallGrouping && overallGrouping.numberOfNewIdeas ? overallGrouping.numberOfNewIdeas : 0;
    const periodStart = settings.periodStart || null;

    return (
        <OurProgrammePortfolioHeader periods={periods}
                                     ourProgrammeContext={ourProgrammeContext}
                                     performancePeriod={settings.performancePeriod}
                                     periodStart={periodStart}
                                     portfolioName={settings.portfolioName}
                                     ownerName={ownerName}
                                     kpiName={selectedKpi.name}
                                     kpiValue={kpiValue}
                                     numberOfNewIdeas={numberOfNewIdeas}
                                     currency={settings.currency}
                                     generatedAt={settings.generatedAt}/>
    )
};
